unit unit_EinzelDatei;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, DB,
  WEBLib.Grids, XData.Web.Client, strutils, WEBLib.DBCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomControl;

type
  TEinzelDatei = class(TForm)
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    Container3: THTMLContainer;
    btnzurueck: TButton;
    TC: TTableControl;
    dsEinzelDatei: TXDataWebDataSet;
    dsEinzelDateiID: TIntegerField;
    dsEinzelDateiDatumUhrzeit: TDateTimeField;
    dsEinzelDateiDateiMime: TStringField;
    dsEinzelDateiDateiName: TStringField;
    dsEinzelDateiDateiGroesse: TIntegerField;
    dsEinzelDateiDateiInhaltText: TStringField;
    dsEinzelDateiDateiInhaltThumb: TStringField;
    dsEinzelDateiProtokoll: TStringField;
    dsEinzelDateiDateiBetreff: TStringField;
    dsEinzelDateiKundennummer: TStringField;
    dsEinzelDateiNummerkomplett: TStringField;
    dsEinzelDateiObjektReferenz: TStringField;
    dsEinzelDateiFahrzeugID: TIntegerField;
    WebImageControl1: TImageControl;
    btnDateiLoeschen: TButton;
    MSGLOESCHEN: TMessageDlg;
    xdsProtokolleLoeschungen: TXDataWebDataSet;
    xdsProtokolleLoeschungenID: TStringField;
    xdsProtokolleLoeschungenDatum: TDateTimeField;
    xdsProtokolleLoeschungenBenutzer: TStringField;
    xdsProtokolleLoeschungenBelegart: TStringField;
    xdsProtokolleLoeschungenBelegnummer: TStringField;
    xdsProtokolleLoeschungenProtokoll: TStringField;
    dsEinzelDateiAuslagerungsdatei: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure btnzurueckClick(Sender: TObject);
    procedure dsEinzelDateiAfterOpen(DataSet: TDataSet);
    procedure WebImageControl1Click(Sender: TObject);
    [async]procedure btnDateiLoeschenClick(Sender: TObject); async;
    procedure dsEinzelDateiAfterDelete(DataSet: TDataSet);
    procedure dsEinzelDateiAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure dsEinzelDateiBeforeDelete(DataSet: TDataSet);
    procedure xdsProtokolleLoeschungenAfterPost(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    EinzeldateiID:string;
    Funktion:string;
    SL:TStringList;
  protected procedure LoadDFMValues; override; end;

var
  EinzelDatei: TEinzelDatei;

implementation
  uses unit1, unit2;
{$R *.dfm}



procedure TEinzelDatei.btnDateiLoeschenClick(Sender: TObject);
var
  mr: TModalResult;
begin
  mr := await(TModalResult, Msgloeschen.ShowDialog('Das Löschen einer Datei kann nicht rückgängig gemacht werden.Wollen Sie die Datei wirklich löschen?', WEBLib.Dialogs.mtConfirmation,[mbYes, mbNo]));
  if mr = mrYes then dsEinzelDatei.Delete;
end;

procedure TEinzelDatei.btnzurueckClick(Sender: TObject);
begin
  self.close;
end;

procedure TEinzelDatei.dsEinzelDateiAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
begin
  self.close;
end;

procedure TEinzelDatei.dsEinzelDateiAfterDelete(DataSet: TDataSet);
begin
  dsEinzelDatei.ApplyUpdates;
end;

procedure TEinzelDatei.dsEinzelDateiAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;
  mytext:string;
  myencoded:string;
  mydecoded:string;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>EinzelDatei</h5></nav>';
  myelement:=container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  btnDateiLoeschen.ParentElement:=myelement;
  container2.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  tc.ParentElement:=myelement;

  container3.parentelement:=myelement;
  myelement:=container3.ElementHandle;
  WebImageControl1.parentelement:=myelement;
  webimagecontrol1.autosize:=false;
  webimagecontrol1.visible:=false;

  TC.RowHeader:=false;
  TC.Visible:=true;
  TC.RowCount:=3;
  TC.colcount:=1;
  mytext:='';
  mytext:=mytext+'<small><i>ID: </i></small>'+dseinzeldateiid.asstring;
  mytext:=mytext+'<br><small><i>Datei: </i></small><b>'+dseinzeldateiDateiName.asstring+'</b>';
  mytext:=mytext+'<br><small><i>vom: </i></small><b>'+formatdatetime('DD.MM.YYYY hh:mm:ss',dseinzeldateiDatumUhrzeit.asdatetime)+'</b>';
  mytext:=mytext+'<br><small><i>Betreff: </i></small><b>'+dseinzeldateiDateiBetreff.asstring+'</b>';
  //mytext:=mytext+'<br><small><i>DateiMime: </i></small>'+dseinzeldateiDateiMime.asstring;
  mytext:=mytext+'<br><small><i>DateiGroesse: </i></small>'+dseinzeldateiDateiGroesse.asstring;
  if dseinzeldateiKundennummer.asstring<>'' then mytext:=mytext+'<br><small><i>Kundennummer: </i></small><b>'+dseinzeldateiKundennummer.asstring+'</b>';
  if dseinzeldateiNummerkomplett.asstring<>'' then mytext:=mytext+'<br><small><i>Belegnummer: </i></small><b>'+dseinzeldateiNummerkomplett.asstring+'</b>';
  if dseinzeldateiObjektreferenz.asstring<>'' then mytext:=mytext+'<br><small><i>Objekt: </i></small><b>'+dseinzeldateiObjektreferenz.asstring+'</b>';
  if (dseinzeldateiFahrzeugID.asstring<>'') AND (dseinzeldateiFahrzeugID.asstring<>'0') then mytext:=mytext+'<br><small><i>Fahrzeug: </i></small><b>'+dseinzeldateiFahrzeugID.asstring+'</b>';

  TC.Cells[0,0]:= mytext;
  if (lowercase(dseinzeldateidateimime.asstring)='.png') OR (lowercase(dseinzeldateidateimime.asstring)='image/png') then
  begin
    webimagecontrol1.visible:=true;
    WebImageControl1.URL := dsEinzelDateiDateiInhaltText.asstring;
  end;
  if (lowercase(dseinzeldateidateimime.asstring)='.jpg') OR (lowercase(dseinzeldateidateimime.asstring)='image/jpeg') then
  begin
    webimagecontrol1.visible:=true;
    WebImageControl1.URL := dsEinzelDateiDateiInhaltText.asstring;
  end;
    if (lowercase(dseinzeldateidateimime.asstring)='.bmp') OR (lowercase(dseinzeldateidateimime.asstring)='image/jpeg') then
  begin
    webimagecontrol1.visible:=true;
    WebImageControl1.URL := dsEinzelDateiDateiInhaltText.asstring;
  end;

  if lowercase(dseinzeldateidateimime.asstring)='.txt' then
  begin
    SL:=TStringList.Create;
    SL.delimiter:=',';
    SL.StrictDelimiter:=true;
    SL.delimitedtext:=dsEinzelDateiDateiInhaltText.asstring;
    myencoded:=sl[1];
    sl.free;
    mydecoded:=web.window.atob(myencoded);
    mydecoded:=ReplaceStr(mydecoded,#13+#10,'<BR>');
    TC.Cells[0,1]:= mydecoded;
  end;

end;

procedure TEinzelDatei.dsEinzelDateiBeforeDelete(DataSet: TDataSet);
begin
  xdsProtokolleLoeschungen.Append;
  xdsProtokolleLoeschungenDatum.AsDateTime:=date+time;
  xdsProtokolleLoeschungenBenutzer.AsString:=BenutzerSchreibzeichen;
  xdsProtokolleLoeschungenBelegart.AsString:='Datei via CadiaWeb';
  xdsProtokolleLoeschungenBelegnummer.AsString:=dsEinzelDateiID.AsString;
  xdsProtokolleLoeschungenProtokoll.AsString:=dsEinzelDateiDateiName.AsString;
  xdsProtokolleLoeschungen.Post;
end;

procedure TEinzelDatei.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  action:=cafree;
end;

procedure TEinzelDatei.WebFormShow(Sender: TObject);
begin
  xdsProtokolleLoeschungen.Load;
  dsEinzelDatei.Close;
  dsEinzeldatei.QueryString:='$filter=ID eq '+EinzeldateiID;
  dsEinzeldatei.Load;
end;

procedure TEinzelDatei.WebImageControl1Click(Sender: TObject);
begin
  webimagecontrol1.AutoSize:=true;
end;

procedure TEinzelDatei.xdsProtokolleLoeschungenAfterPost(DataSet: TDataSet);
begin
  xdsprotokolleloeschungen.ApplyUpdates;
end;

procedure TEinzelDatei.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebImageControl1 := TImageControl.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  btnzurueck := TButton.Create(Self);
  TC := TTableControl.Create(Self);
  btnDateiLoeschen := TButton.Create(Self);
  MSGLOESCHEN := TMessageDlg.Create(Self);
  dsEinzelDatei := TXDataWebDataSet.Create(Self);
  dsEinzelDateiID := TIntegerField.Create(Self);
  dsEinzelDateiDatumUhrzeit := TDateTimeField.Create(Self);
  dsEinzelDateiDateiMime := TStringField.Create(Self);
  dsEinzelDateiDateiName := TStringField.Create(Self);
  dsEinzelDateiDateiGroesse := TIntegerField.Create(Self);
  dsEinzelDateiDateiInhaltText := TStringField.Create(Self);
  dsEinzelDateiDateiInhaltThumb := TStringField.Create(Self);
  dsEinzelDateiProtokoll := TStringField.Create(Self);
  dsEinzelDateiDateiBetreff := TStringField.Create(Self);
  dsEinzelDateiKundennummer := TStringField.Create(Self);
  dsEinzelDateiNummerkomplett := TStringField.Create(Self);
  dsEinzelDateiObjektReferenz := TStringField.Create(Self);
  dsEinzelDateiFahrzeugID := TIntegerField.Create(Self);
  dsEinzelDateiAuslagerungsdatei := TStringField.Create(Self);
  xdsProtokolleLoeschungen := TXDataWebDataSet.Create(Self);
  xdsProtokolleLoeschungenID := TStringField.Create(Self);
  xdsProtokolleLoeschungenDatum := TDateTimeField.Create(Self);
  xdsProtokolleLoeschungenBenutzer := TStringField.Create(Self);
  xdsProtokolleLoeschungenBelegart := TStringField.Create(Self);
  xdsProtokolleLoeschungenBelegnummer := TStringField.Create(Self);
  xdsProtokolleLoeschungenProtokoll := TStringField.Create(Self);

  WebImageControl1.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  TC.BeforeLoadDFMValues;
  btnDateiLoeschen.BeforeLoadDFMValues;
  MSGLOESCHEN.BeforeLoadDFMValues;
  dsEinzelDatei.BeforeLoadDFMValues;
  dsEinzelDateiID.BeforeLoadDFMValues;
  dsEinzelDateiDatumUhrzeit.BeforeLoadDFMValues;
  dsEinzelDateiDateiMime.BeforeLoadDFMValues;
  dsEinzelDateiDateiName.BeforeLoadDFMValues;
  dsEinzelDateiDateiGroesse.BeforeLoadDFMValues;
  dsEinzelDateiDateiInhaltText.BeforeLoadDFMValues;
  dsEinzelDateiDateiInhaltThumb.BeforeLoadDFMValues;
  dsEinzelDateiProtokoll.BeforeLoadDFMValues;
  dsEinzelDateiDateiBetreff.BeforeLoadDFMValues;
  dsEinzelDateiKundennummer.BeforeLoadDFMValues;
  dsEinzelDateiNummerkomplett.BeforeLoadDFMValues;
  dsEinzelDateiObjektReferenz.BeforeLoadDFMValues;
  dsEinzelDateiFahrzeugID.BeforeLoadDFMValues;
  dsEinzelDateiAuslagerungsdatei.BeforeLoadDFMValues;
  xdsProtokolleLoeschungen.BeforeLoadDFMValues;
  xdsProtokolleLoeschungenID.BeforeLoadDFMValues;
  xdsProtokolleLoeschungenDatum.BeforeLoadDFMValues;
  xdsProtokolleLoeschungenBenutzer.BeforeLoadDFMValues;
  xdsProtokolleLoeschungenBelegart.BeforeLoadDFMValues;
  xdsProtokolleLoeschungenBelegnummer.BeforeLoadDFMValues;
  xdsProtokolleLoeschungenProtokoll.BeforeLoadDFMValues;
  try
    Name := 'EinzelDatei';
    Width := 260;
    Height := 617;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebImageControl1.SetParentComponent(Self);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 32;
    WebImageControl1.Top := 296;
    WebImageControl1.Width := 100;
    WebImageControl1.Height := 41;
    WebImageControl1.HeightStyle := ssAuto;
    WebImageControl1.WidthStyle := ssAuto;
    WebImageControl1.HeightPercent := 100.000000000000000000;
    WebImageControl1.WidthPercent := 100.000000000000000000;
    WebImageControl1.ChildOrder := 6;
    WebImageControl1.ElementPosition := epIgnore;
    SetEvent(WebImageControl1, Self, 'OnClick', 'WebImageControl1Click');
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ChildOrder := 1;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 2;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 3;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 0;
    btnzurueck.Top := 156;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := -1;
    TC.Top := 191;
    TC.Width := 247;
    TC.Height := 91;
    TC.ElementClassName := 'table table-bordered border-primary';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 3;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'thead-light';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    TC.WordWrap := True;
    TC.ColCount := 1;
    btnDateiLoeschen.SetParentComponent(Self);
    btnDateiLoeschen.Name := 'btnDateiLoeschen';
    btnDateiLoeschen.Left := 8;
    btnDateiLoeschen.Top := 380;
    btnDateiLoeschen.Width := 96;
    btnDateiLoeschen.Height := 25;
    btnDateiLoeschen.Caption := 'Datei l'#246'schen';
    btnDateiLoeschen.ChildOrder := 4;
    btnDateiLoeschen.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnDateiLoeschen.ElementFont := efCSS;
    btnDateiLoeschen.ElementPosition := epIgnore;
    btnDateiLoeschen.HeightStyle := ssAuto;
    btnDateiLoeschen.HeightPercent := 100.000000000000000000;
    btnDateiLoeschen.WidthStyle := ssAuto;
    btnDateiLoeschen.WidthPercent := 100.000000000000000000;
    SetEvent(btnDateiLoeschen, Self, 'OnClick', 'btnDateiLoeschenClick');
    MSGLOESCHEN.SetParentComponent(Self);
    MSGLOESCHEN.Name := 'MSGLOESCHEN';
    MSGLOESCHEN.Left := 136;
    MSGLOESCHEN.Top := 416;
    MSGLOESCHEN.Width := 24;
    MSGLOESCHEN.Height := 24;
    MSGLOESCHEN.HeightStyle := ssAuto;
    MSGLOESCHEN.WidthStyle := ssAuto;
    MSGLOESCHEN.Buttons := [mbYes,mbNo];
    MSGLOESCHEN.DialogType := mtConfirmation;
    MSGLOESCHEN.Message := 'Das L'#246'schen einer Datei kann nicht r'#252'ckg'#228'ngig gemacht werden.Wollen Sie die Datei wirklich l'#246'schen?';
    MSGLOESCHEN.Opacity := 0.200000000000000000;
    MSGLOESCHEN.ElementButtonClassName := 'btn';
    MSGLOESCHEN.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    MSGLOESCHEN.ElementTitleClassName := 'text-body';
    MSGLOESCHEN.ElementContentClassName := 'text-body';
    dsEinzelDatei.SetParentComponent(Self);
    dsEinzelDatei.Name := 'dsEinzelDatei';
    dsEinzelDatei.AfterApplyUpdates := dsEinzelDateiAfterApplyUpdates;
    dsEinzelDatei.AfterOpen := dsEinzelDateiAfterOpen;
    dsEinzelDatei.BeforeDelete := dsEinzelDateiBeforeDelete;
    dsEinzelDatei.AfterDelete := dsEinzelDateiAfterDelete;
    dsEinzelDatei.EntitySetName := 'DokumenteDateien';
    dsEinzelDatei.Connection := DM2.XDataWebConnection1;
    dsEinzelDatei.QueryTop := 1;
    dsEinzelDatei.Left := 112;
    dsEinzelDatei.Top := 312;
    dsEinzelDateiID.SetParentComponent(dsEinzelDatei);
    dsEinzelDateiID.Name := 'dsEinzelDateiID';
    dsEinzelDateiID.FieldName := 'ID';
    dsEinzelDateiDatumUhrzeit.SetParentComponent(dsEinzelDatei);
    dsEinzelDateiDatumUhrzeit.Name := 'dsEinzelDateiDatumUhrzeit';
    dsEinzelDateiDatumUhrzeit.FieldName := 'DatumUhrzeit';
    dsEinzelDateiDateiMime.SetParentComponent(dsEinzelDatei);
    dsEinzelDateiDateiMime.Name := 'dsEinzelDateiDateiMime';
    dsEinzelDateiDateiMime.FieldName := 'DateiMime';
    dsEinzelDateiDateiMime.Size := 50;
    dsEinzelDateiDateiName.SetParentComponent(dsEinzelDatei);
    dsEinzelDateiDateiName.Name := 'dsEinzelDateiDateiName';
    dsEinzelDateiDateiName.FieldName := 'DateiName';
    dsEinzelDateiDateiName.Size := 255;
    dsEinzelDateiDateiGroesse.SetParentComponent(dsEinzelDatei);
    dsEinzelDateiDateiGroesse.Name := 'dsEinzelDateiDateiGroesse';
    dsEinzelDateiDateiGroesse.FieldName := 'DateiGroesse';
    dsEinzelDateiDateiInhaltText.SetParentComponent(dsEinzelDatei);
    dsEinzelDateiDateiInhaltText.Name := 'dsEinzelDateiDateiInhaltText';
    dsEinzelDateiDateiInhaltText.FieldName := 'DateiInhaltText';
    dsEinzelDateiDateiInhaltText.Size := 255;
    dsEinzelDateiDateiInhaltThumb.SetParentComponent(dsEinzelDatei);
    dsEinzelDateiDateiInhaltThumb.Name := 'dsEinzelDateiDateiInhaltThumb';
    dsEinzelDateiDateiInhaltThumb.FieldName := 'DateiInhaltThumb';
    dsEinzelDateiDateiInhaltThumb.Size := 255;
    dsEinzelDateiProtokoll.SetParentComponent(dsEinzelDatei);
    dsEinzelDateiProtokoll.Name := 'dsEinzelDateiProtokoll';
    dsEinzelDateiProtokoll.FieldName := 'Protokoll';
    dsEinzelDateiProtokoll.Size := 255;
    dsEinzelDateiDateiBetreff.SetParentComponent(dsEinzelDatei);
    dsEinzelDateiDateiBetreff.Name := 'dsEinzelDateiDateiBetreff';
    dsEinzelDateiDateiBetreff.FieldName := 'DateiBetreff';
    dsEinzelDateiDateiBetreff.Size := 50;
    dsEinzelDateiKundennummer.SetParentComponent(dsEinzelDatei);
    dsEinzelDateiKundennummer.Name := 'dsEinzelDateiKundennummer';
    dsEinzelDateiKundennummer.FieldName := 'Kundennummer';
    dsEinzelDateiKundennummer.Size := 13;
    dsEinzelDateiNummerkomplett.SetParentComponent(dsEinzelDatei);
    dsEinzelDateiNummerkomplett.Name := 'dsEinzelDateiNummerkomplett';
    dsEinzelDateiNummerkomplett.FieldName := 'Nummerkomplett';
    dsEinzelDateiNummerkomplett.Size := 10;
    dsEinzelDateiObjektReferenz.SetParentComponent(dsEinzelDatei);
    dsEinzelDateiObjektReferenz.Name := 'dsEinzelDateiObjektReferenz';
    dsEinzelDateiObjektReferenz.FieldName := 'ObjektReferenz';
    dsEinzelDateiObjektReferenz.Size := 13;
    dsEinzelDateiFahrzeugID.SetParentComponent(dsEinzelDatei);
    dsEinzelDateiFahrzeugID.Name := 'dsEinzelDateiFahrzeugID';
    dsEinzelDateiFahrzeugID.FieldName := 'FahrzeugID';
    dsEinzelDateiAuslagerungsdatei.SetParentComponent(dsEinzelDatei);
    dsEinzelDateiAuslagerungsdatei.Name := 'dsEinzelDateiAuslagerungsdatei';
    dsEinzelDateiAuslagerungsdatei.FieldName := 'Auslagerungsdatei';
    xdsProtokolleLoeschungen.SetParentComponent(Self);
    xdsProtokolleLoeschungen.Name := 'xdsProtokolleLoeschungen';
    xdsProtokolleLoeschungen.AfterPost := xdsProtokolleLoeschungenAfterPost;
    xdsProtokolleLoeschungen.EntitySetName := 'ProtokolleLoeschungen';
    xdsProtokolleLoeschungen.Connection := DM2.XDataWebConnection1;
    xdsProtokolleLoeschungen.QueryTop := 1;
    xdsProtokolleLoeschungen.Left := 104;
    xdsProtokolleLoeschungen.Top := 472;
    xdsProtokolleLoeschungenID.SetParentComponent(xdsProtokolleLoeschungen);
    xdsProtokolleLoeschungenID.Name := 'xdsProtokolleLoeschungenID';
    xdsProtokolleLoeschungenID.FieldName := 'ID';
    xdsProtokolleLoeschungenID.Size := 38;
    xdsProtokolleLoeschungenDatum.SetParentComponent(xdsProtokolleLoeschungen);
    xdsProtokolleLoeschungenDatum.Name := 'xdsProtokolleLoeschungenDatum';
    xdsProtokolleLoeschungenDatum.FieldName := 'Datum';
    xdsProtokolleLoeschungenBenutzer.SetParentComponent(xdsProtokolleLoeschungen);
    xdsProtokolleLoeschungenBenutzer.Name := 'xdsProtokolleLoeschungenBenutzer';
    xdsProtokolleLoeschungenBenutzer.FieldName := 'Benutzer';
    xdsProtokolleLoeschungenBenutzer.Size := 50;
    xdsProtokolleLoeschungenBelegart.SetParentComponent(xdsProtokolleLoeschungen);
    xdsProtokolleLoeschungenBelegart.Name := 'xdsProtokolleLoeschungenBelegart';
    xdsProtokolleLoeschungenBelegart.FieldName := 'Belegart';
    xdsProtokolleLoeschungenBelegart.Size := 50;
    xdsProtokolleLoeschungenBelegnummer.SetParentComponent(xdsProtokolleLoeschungen);
    xdsProtokolleLoeschungenBelegnummer.Name := 'xdsProtokolleLoeschungenBelegnummer';
    xdsProtokolleLoeschungenBelegnummer.FieldName := 'Belegnummer';
    xdsProtokolleLoeschungenBelegnummer.Size := 25;
    xdsProtokolleLoeschungenProtokoll.SetParentComponent(xdsProtokolleLoeschungen);
    xdsProtokolleLoeschungenProtokoll.Name := 'xdsProtokolleLoeschungenProtokoll';
    xdsProtokolleLoeschungenProtokoll.FieldName := 'Protokoll';
    xdsProtokolleLoeschungenProtokoll.Size := 255;
  finally
    WebImageControl1.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    TC.AfterLoadDFMValues;
    btnDateiLoeschen.AfterLoadDFMValues;
    MSGLOESCHEN.AfterLoadDFMValues;
    dsEinzelDatei.AfterLoadDFMValues;
    dsEinzelDateiID.AfterLoadDFMValues;
    dsEinzelDateiDatumUhrzeit.AfterLoadDFMValues;
    dsEinzelDateiDateiMime.AfterLoadDFMValues;
    dsEinzelDateiDateiName.AfterLoadDFMValues;
    dsEinzelDateiDateiGroesse.AfterLoadDFMValues;
    dsEinzelDateiDateiInhaltText.AfterLoadDFMValues;
    dsEinzelDateiDateiInhaltThumb.AfterLoadDFMValues;
    dsEinzelDateiProtokoll.AfterLoadDFMValues;
    dsEinzelDateiDateiBetreff.AfterLoadDFMValues;
    dsEinzelDateiKundennummer.AfterLoadDFMValues;
    dsEinzelDateiNummerkomplett.AfterLoadDFMValues;
    dsEinzelDateiObjektReferenz.AfterLoadDFMValues;
    dsEinzelDateiFahrzeugID.AfterLoadDFMValues;
    dsEinzelDateiAuslagerungsdatei.AfterLoadDFMValues;
    xdsProtokolleLoeschungen.AfterLoadDFMValues;
    xdsProtokolleLoeschungenID.AfterLoadDFMValues;
    xdsProtokolleLoeschungenDatum.AfterLoadDFMValues;
    xdsProtokolleLoeschungenBenutzer.AfterLoadDFMValues;
    xdsProtokolleLoeschungenBelegart.AfterLoadDFMValues;
    xdsProtokolleLoeschungenBelegnummer.AfterLoadDFMValues;
    xdsProtokolleLoeschungenProtokoll.AfterLoadDFMValues;
  end;
end;

end.
